export enum CompanyRevenue {
  NONE,
  BELOW100K,
  BETWEEN100K_AND500K,
  BETWEEN500K_AND1M,
  BETWEEN1M_AND5M,
  ABOVE5M,
}
